import { render, staticRenderFns } from "./GenericSettings.vue?vue&type=template&id=28a3815e&scoped=true&"
import script from "./GenericSettings.vue?vue&type=script&lang=js&"
export * from "./GenericSettings.vue?vue&type=script&lang=js&"
import style0 from "./GenericSettings.vue?vue&type=style&index=0&id=28a3815e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a3815e",
  null
  
)

export default component.exports